import {
  GetCurrentConversationsRequest,
  CommunicationParty,
  ConversationDto,
  GetCurrentMessagesRequest,
  SendMessageToCustomerCommand,
  GetNewMessagesRequest,
  DeleteConversationCommand,
  GetTotalUnReadCountRequest,
  GetTotalUnReadCountResponse,
  UpdateReadStatusCommand,
  TrackableMessageDto,
  IMLabel,
} from "@/types/interface/IM/IMTypes"
import axios from "@/libs/netAxios"
import { AxiosResponse } from "axios"
import store from "@/store"

export const getConversations = async (
  pageIndex: number = 1,
  keyword?: string,
  isExactSearch: boolean = true
): Promise<ConversationDto[]> => {
  const getCurrentConversationsRequest: GetCurrentConversationsRequest = {
    requestFrom: CommunicationParty.merchant,
    pageIndex,
    pageSize: 10,
    keyword,
    isExactSearch,
    ts: store.state.ImRequestTimeStamp,
    merchIds: store.state.merchIds,
  }

  const response = await axios.post(
    "/api/Communicate/conversations",
    getCurrentConversationsRequest
  )
  return response.data
}

export const getRecentMessages = async (
  request: GetCurrentMessagesRequest,
  merchId: string
): Promise<TrackableMessageDto[]> => {
  let response: AxiosResponse<any>
  response = await axios.request({
    headers: {
      merchId,
    },
    method: "POST",
    url: "/api/Communicate/messages",
    data: request,
  })
  return response.data
}

export const sendMessageToCustomer = async (
  messageToSend: SendMessageToCustomerCommand,
  merchId: string
) => {
  const response = await axios.request({
    method: "POST",
    url: "/api/Communicate/customer",
    headers: {
      merchId,
    },
    data: messageToSend,
  })
  return response
}

export const getNewMessages = async (
  request: GetNewMessagesRequest
): Promise<TrackableMessageDto[]> => {
  const response = await axios.post("/api/Communicate/newMessages", request)
  return response.data
}

export const deleteConversation = async (
  request: DeleteConversationCommand
): Promise<AxiosResponse<any>> => {
  return await axios.post("/api/Communicate/conversation/delete", request)
}

export const getUnreadMessageCount = async (
  request: GetTotalUnReadCountRequest
): Promise<GetTotalUnReadCountResponse> => {
  const result = await axios.post("/api/Communicate/unread/count", request)
  store.commit("handleUnreadMessageCount", result.data.count)
  return result.data
}

export const changeMessageReadStatus = async (
  request: UpdateReadStatusCommand
) => {
  let result
  if (store.state.isPc) {
    result = await axios.post("/api/Communicate/read", request, {
      headers: {
        merchId: request.merchId,
      },
    })
  } else {
    result = await axios.post("/api/Communicate/read", request)
  }
  if (result.status === 200) {
    store.commit("handleUnreadMessageCount", result.data.count)
  }
}

export const addLabel = async (params: IMLabel) => {
  const response = await axios.post("/api/Merch/labelCustomer", params, {
    headers: {
      merchId: params.merchId,
    },
  })
  return response
}

export const deleteLabel = async (id: string, merchId: string) => {
  const response = await axios.post(
    "/api/Merch/removeCustomerLabel",
    { id },
    {
      headers: {
        merchId,
      },
    }
  )
  return response
}
